import BaseAPI from '@/services/api/internal/tools/baseAPI';

const AuthorsAPI = new BaseAPI({
  url: `${process.env.MYPREDITY_BASE_URI}/authors`,
});

export default AuthorsAPI;
